
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import MachinesList1 from "./machineList";
import axios from "axios";
import { apiClient } from "../api";

const NewProdForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const handleGoBack = () => { navigate(-1); };

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  const [codMaq, setCodMaq] = useState("");
  const [idProd, setIdProd] = useState("");
  const [model] = useState("1"); // Modelo fijo: ya no se pide al usuario
  const [nameProd, setNameProd] = useState("");
  const [descProd, setDescProd] = useState("");
  const [unidad, setUnidad] = useState("u");
  const [ciclosHora, setCiclosHora] = useState("");
  const [undPorCiclo, setUndPorCiclo] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = {
        id_c: company.id_c,
        cod_maq: codMaq,
        id_prod: idProd,
        model: model,
        name_prod: nameProd,
        description_prod:descProd,
        und_prod: unidad,
        ciclo_x_hr_prod_std: ciclosHora,
        und_prod_x_oper: undPorCiclo,
        id_user: user.id_u
      };

      //await axios.post("/products", data);
      await apiClient.post("/products", data); // ✅ Esto usa la URL correcta dinámica


      alert("✅ Producto registrado exitosamente");
      handleGoBack();
    } catch (error) {
      console.error("❌ Error al registrar producto:", error);
      alert("Ocurrió un error al registrar el producto.");
    }
  };

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label htmlFor="cod_maquina">Código de Máquina:</label></td>
                <td>
                  <MachinesList1
                    id_c={company.id_c}
                    onSelect={(value) => setCodMaq(value)}
                  />
                </td>
              </tr>
              <tr>
                <td><label htmlFor="cod_producto">Código Producto:</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    value={idProd}
                    onChange={(e) => setIdProd(e.target.value)}
                    id="cod_producto"
                    name="cod_producto"
                    required
                  />
                </td>
              </tr>
              <tr>
                <td><label htmlFor="nombre_producto">Nombre de Producto:</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    value={nameProd}
                    onChange={(e) => setNameProd(e.target.value)}
                    id="nombre_producto"
                    name="nombre_producto"
                    required
                  />
                </td>
              </tr>
              <tr>
                <td><label htmlFor="descripcion_producto">Descripción de Producto:</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="descripcion_producto"
                    name="descripcion_producto"
                    rows="3"
                    value={descProd}
                    onChange={(e) => setDescProd(e.target.value)}
                    required
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td><label htmlFor="unidad">Unidad de Producto:</label></td>
                <td>
                  <select
                    className="input1"
                    value={unidad}
                    onChange={(e) => setUnidad(e.target.value)}
                    id="unidad"
                    name="unidad"
                    required
                  >
                    <option value="u">u (Unidades)</option>
                    <option value="m">m (Metros)</option>
                    <option value="kg">kg (Kilogramos)</option>
                    <option value="kit">Kit</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td><label htmlFor="ciclos_hora">Ciclos por Hora:</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={ciclosHora}
                    onChange={(e) => setCiclosHora(e.target.value)}
                    id="ciclos_hora"
                    name="ciclos_hora"
                    min="0"
                    step="any" // ✅ Permite cualquier valor decimal
                    required
                  />
                </td>
              </tr>
              {/*}
              <tr>
                <td><label htmlFor="unidades_por_ciclo">Unidades por Ciclo:</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={undPorCiclo}
                    onChange={(e) => setUndPorCiclo(e.target.value)}
                    id="unidades_por_ciclo"
                    name="unidades_por_ciclo"
                    min="0"
                    required
                  />
                </td>
              </tr>
              */}
              {/* v2 */}
              <tr>
  <td><label htmlFor="unidades_por_ciclo">Unidades por Ciclo:</label></td>
  <td>
    <input
      className="input1"
      type="number"
      value={undPorCiclo}
      onChange={(e) => setUndPorCiclo(e.target.value)}
      id="unidades_por_ciclo"
      name="unidades_por_ciclo"
      min="0"
      step="any"
      required
    />
  </td>
</tr>
            </tbody>
          </table>

          <button type="submit" className="button7">{t("prodList12")}</button>
          <button
            type="button"
            className="button7"
            onClick={handleGoBack}
          >
            {t("prodList13")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewProdForm;
